<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/community/community' }"
            >小区管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>小区标签</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button
          type="success"
          style="margin-left: 8vh"
          icon="el-icon-plus"
          @click="handleNewAdd"
          size="mini"
          >新增标签</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="sort" label="排序" align="center" />
      <el-table-column prop="title" label="标签名称" align="center" />
      <el-table-column prop="created_at" label="创建时间" align="center" />
      <!-- <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column> -->
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-edit"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDels(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="小区标签" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
            <el-col :span="24">
              <el-form-item label="公司状态">
                <el-radio-group v-model="form.status">
                  <el-radio
                    v-for="item in regionTypes"
                    :label="item.label"
                    :key="item.label"
                    >{{ item.text }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import tableCommon from "../../../mixins/table-common";
import { getTag, addTag, editTag, deleteTag } from "../../api/tag";
export default {
  mixins: [tableCommon],
  data() {
    return {
      // 请求地址api
      api: {
        list: getTag,
        add: addTag,
        del: deleteTag,
        edit: editTag,
      },
      // 规则验证
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      // 传参
      form: {},
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        size: 10,
      },
      tableData: [],
    };
  },
  mounted() {
    this.searchForm.xiaoqu_id = this.$route.query.id;
    this.getTags();
  },
  methods: {
    // 获取列表
    getTags() {
      getTag(this.searchForm).then((res) => {
        this.tableData = res.data.records;
        console.log(this.tableData);
      });
    },
    // 状态修改
    // changeStatus(res) {
    //   this.form = JSON.parse(JSON.stringify(res));
    //   // this.handleEdit();
    //   this.actionType = "edit";
    //   // const { city_name, company_name, ...rest } = this.form;
    //   // this.form = rest;
    //   editCompany(this.form).then((msg) => {
    //     if (msg.code !== 200) return this.$message("获取状态失败");
    //   });
    // },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.form.xiaoqu_id = this.$route.query.id;
      this.handleAdd();
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      this.handleEdit();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
    async singleDels(row, idKey, ...args) {
      const delFn = this.api.del;
      const text = args.length ? `是否删除这条数据` : `是否删除这条数据`;
      this.$confirm(text, "删除数据", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await delFn(idKey);
        if (res.code !== 200)
          return this.$message.error(res.msg ? res.msg : "删除失败!");
        this.$message.success("删除成功");
        this.getTags();
      });
    },
    // 确定按钮
    async submitForms(res) {
      try {
        this.$refs["form"].validate((valid, err) => {
          if (valid) {
            this.btnLoading = true;
            if (this.actionType === "edit") {
              let fn = this.api.edit;
              fn(this.form).then((response) => {
                this.addOrEditOpen = false;
                this.btnLoading = false;
                this.$message.success("修改成功");
                this.getTags();
              });
            } else if (this.actionType === "add") {
              let fn = this.api.add;
              fn(this.form).then((response) => {
                this.addOrEditOpen = false;
                this.btnLoading = false;
                this.$message.success("添加成功");
                this.getTags();
              });
            }
          } else {
            console.log(res);
            this.form.category_ids = res.split(",");
            console.log(this.form.category_ids);
            this.btnLoading = false;
            if (this.isFormErr) {
              Object.keys(err).map((key) => {
                setTimeout(() => {
                  this.$modal.msgError(err[key][0].message);
                }, 100);
              });
            }
          }
        });
      } catch (err) {
        this.btnLoading = false;
      }
    },
  },
};
</script>
  <style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/community/tag.vue